// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Menu_V2_Types_MenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic_Promotions_RPC_Sites_Types from "../Restaumatic.Promotions.RPC.Sites.Types/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var filterPromotions = function (v) {
    return function (v1) {
        if (v1 instanceof Data_Either.Right) {
            var isRelevantPromotion = function (p) {
                return Data_Set.member(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(v)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "enabledMenuConsumers";
                    }
                })()))(Type_Proxy["Proxy"].value)(p)));
            };
            var filtered = Data_Array.filter(isRelevantPromotion)(Data_Record.getField(Restaumatic_Promotions_RPC_Sites_Types.hasFieldGetActivePromotio1(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "promotions";
                }
            })()))(Type_Proxy["Proxy"].value)(v1.value0));
            return new Data_Either.Right({
                promotions: filtered,
                coupons: Data_Record.getField(Restaumatic_Promotions_RPC_Sites_Types.hasFieldGetActivePromotio1(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "coupons";
                    }
                })()))(Type_Proxy["Proxy"].value)(v1.value0)
            });
        };
        return v1;
    };
};
var getActivePromotions = function (menuConsumer) {
    return Data_Functor.map(Data_Functor.functorFn)(Data_Functor.map(Effect_Aff.functorAff)(Data_Functor.map(Data_Either.functorEither)(filterPromotions(menuConsumer))))((function () {
        var $5 = Effect_Aff_Class.liftAff(Effect_Aff_Class.monadAffAff);
        var $6 = Restaumatic_Site_RPC.sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Promotions_RPC_Sites_Types.encodeGetActivePromotionsRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Promotions_RPC_Sites_Types.encodeGetActivePromotionsRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Promotions_RPC_Sites_Types.decodeGetActivePromotionsResponse))(Restaumatic_Promotions_RPC_Sites_Types.rPCMethodNameGetActivePro);
        return function ($7) {
            return $5($6($7));
        };
    })());
};
var promotionsBackend = {
    getActivePromotions: getActivePromotions
};
export {
    promotionsBackend
};
//# sourceMappingURL=index.js.map
